<template>
    <div class="footer">
        <div class="content">
            <template v-for="item in menu">
                <div class="list-box" :key="item.index" v-if="item.children&&item.children.length!=0">
                    <div class="title">{{ item.title }}</div>
                    <div class="list">
                        <div class="item" v-for="val in item.children" :key="val.index" @click="goto(val)">{{val.title}}</div>
                    </div>
                </div>
            </template>
            <div class="line"></div>
            <div class="list">
                <div class="item"> 
                    ©2025 Dell Inc. or its subsidiaries. All Rights Reserved.
                    <img class="icon" alt="" src="@/assets/pc/common/guohui.webp">
                </div>
                <div class="item"> 京ICP备11038982号-18 </div>
            </div>
        </div>
    </div>
</template>
<script>
import { $data } from '@/setting/data';
import { gotoListPage } from '@/uitls/page';
export default {
    name: 'FooterPC',
    data() {
        return {
            menu: $data.menu
        }
    },
    methods: {
        goto(val) {
            this.$gioAction('navbottomclick_hk', { 'jingtaititle_hk': val.title });
            gotoListPage(val, this.$router)
        }
    }
}
</script>
<style scoped lang="scss">
.footer {
    padding: 50px 0;
    background: #F3F3F3;
    .content{
        width: 1170px;
        margin: 0 auto;
        .title{
            margin-bottom: 15px;
            font-weight: bold;
            font-size: 16px;
            color: #000000;
            line-height: 21px;
        }
        .list{
            display: flex;
            flex-wrap: wrap;
            column-gap: 40px;
            justify-content: flex-start;
            .item{
                display: flex;
                align-items: center;
                margin-bottom: 20px;
                font-size: 14px;
                color: #666666;
                line-height: 21px;
                cursor: pointer;
            }
        }
        .line{
            width: 100%;
            height: 1px;
            background: #E5E5E5;
            margin: 0 0 20px;
        }
        @include pc-style-note {
            width: 940px;
            .title{
                font-size: 14px;
                line-height: 19px;
            }
           .list{
                column-gap: 30px;
               .item{
                    font-size: 12px;
                    line-height: 17px;
               }
           }
        }
    }
}
</style>